/* ------------------------- External Dependencies -------------------------- */
import React from 'react';
import { Box } from 'atomic'
/* ---------------------------- Module Package ------------------------------ */
export default props => <Box {...props} onClick={props.drawerOpen} />



// WEBPACK FOOTER //
// ./src/interface/containers/drawer/DrawerOpen/render/index.js